import {Injector, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {MatMenuModule} from '@angular/material/menu';
import { DropdownUserMenuModuleGeneric} from './dropdown-menu/dropdown-menu.module';
import { MainHeaderUserDetailsModuleGeneric} from './user-details/user-details.module';
import { UserLoginButtonModuleGeneric} from './login-button/login-button.module';
import { UserLoginComponentGeneric } from './user-login.component';
import { Collapsible2DirectiveModule } from '@signature-it/ngx-generic/directives';
import {createCustomElement} from "@angular/elements";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DropdownUserMenuModuleGeneric,
        MainHeaderUserDetailsModuleGeneric,
        UserLoginButtonModuleGeneric,
        Collapsible2DirectiveModule,
        MatMenuModule
    ],
    declarations: [UserLoginComponentGeneric],
    exports: [UserLoginComponentGeneric]
})
export class UserLoginModuleGeneric {
    constructor(private injector: Injector) {
        const CarouselComp = createCustomElement(UserLoginComponentGeneric, {injector});
        !customElements.get('ngx-user-login-component') && customElements.define('ngx-user-login-component', CarouselComp);
    }
}
